import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class ChunkErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false,
      error: null
    };
  }

  static getDerivedStateFromError(error: Error): State {
    return {
      hasError: true,
      error
    };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    if (error.name === 'ChunkLoadError' || error.message.includes('Loading chunk')) {
      // Force a fresh request bypassing browser cache — reload() reuses cached HTML
      window.location.href = window.location.pathname + '?_v=' + Date.now();
    }
  }

  private handleReload = () => {
    // Clear the error state
    this.setState({ hasError: false, error: null });
    // Reload the page
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return <div>Cargando...</div>;
    }

    return this.props.children;
  }
}

export default ChunkErrorBoundary;